/**
 * Analytics_Service.ts
 * Dashboard analytics (sk-catalog-api /api/v1/analytics).
 */

import axiosInstance from '../../api/axiosInstance';
import { Catalog_Analytics_Overview_Url } from '../../api/endpoints';

export interface AnalyticsSeriesPoint {
  date: string;          // YYYY-MM-DD
  itemsAdded: number;
  itemsPublished: number;
}

export interface AnalyticsOverview {
  today: {
    itemsAdded: number;
    itemsPublished: number;
    typesCreated: number;
    categoriesCreated: number;
    tagsCreated: number;
    collectionsCreated: number;
  };
  totals: {
    items: number;
    published: number;
    types: number;
    categories: number;
    tags: number;
    collections: number;
  };
  byState: Record<string, number>;
  series: AnalyticsSeriesPoint[];
  generatedAt: string;
}

export const getAnalyticsOverview = async (): Promise<AnalyticsOverview> => {
  const { data } = await axiosInstance.get<AnalyticsOverview>(Catalog_Analytics_Overview_Url);
  return data;
};
